import { atomWithQuery } from "jotai-tanstack-query";
import { authAtom } from "../../auth/atoms";
import { loadBusinessInterests } from "../../../apis/business";
import { BusinessInterestType } from "../../../types/tagging";

/**
 * Shared atom for business interests WITHOUT photos
 * Used by most components (venue lists, maps, etc.)
 * This prevents duplicate API calls by providing a single source of truth
 */
export const businessInterestsAtom = atomWithQuery((get) => {
  const auth = get(authAtom);
  const accessToken = auth?.data?.accessToken;

  return {
    queryKey: ["businessInterests", accessToken, false],
    queryFn: async () => {
      if (!accessToken) {
        return [] as BusinessInterestType[];
      }
      const response = await loadBusinessInterests(accessToken, false);
      if (response.status === "error") {
        return [] as BusinessInterestType[];
      }
      return response.data;
    },
    enabled: !!accessToken,
    staleTime: Infinity, // Data is only invalidated by mutations
  };
});

/**
 * Shared atom for business interests WITH photos
 * Used only by NotificationSettings component which displays venue images
 */
export const businessInterestsWithPhotosAtom = atomWithQuery((get) => {
  const auth = get(authAtom);
  const accessToken = auth?.data?.accessToken;

  return {
    queryKey: ["businessInterests", accessToken, true],
    queryFn: async () => {
      if (!accessToken) {
        return [] as BusinessInterestType[];
      }
      const response = await loadBusinessInterests(accessToken, true);
      if (response.status === "error") {
        return [] as BusinessInterestType[];
      }
      return response.data;
    },
    enabled: !!accessToken,
    staleTime: Infinity, // Data is only invalidated by mutations
  };
});
